import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useMyContext } from "@/context/ContextApi";

export default function WelcomePage() {
  const { t } = useTranslation();
  const { token } = useMyContext();

  return (
    <div className="relative flex-1 flex flex-col items-center justify-center overflow-hidden min-h-[calc(100vh-64px)]">

      {/* Subtle dot-grid background */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "radial-gradient(oklch(0.35 0.04 270) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
          opacity: 0.25,
        }}
      />

      {/* Glow blob */}
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] rounded-full bg-violet-600/10 blur-[120px]" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-4 gap-6">

        {/* Tag */}
        <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-violet-400 border border-violet-500/30 bg-violet-500/5 rounded-full px-4 py-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-violet-400 animate-pulse" />
          {t('welcome_tag')}
        </span>

        {/* Heading */}
        <h1 className="text-7xl sm:text-8xl md:text-9xl font-black tracking-tighter leading-none">
          <span
            style={{
              background: "linear-gradient(135deg, #fff 0%, oklch(0.75 0.18 285) 50%, oklch(0.55 0.28 285) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {t('welcome_title')}
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-zinc-400 text-base sm:text-lg max-w-sm leading-relaxed">
          {t('welcome_subtitle1')}<br />
          {t('welcome_subtitle2')}
        </p>

        {/* CTAs */}
        <div className="flex items-center gap-3 mt-2">
          {token ? (
            <Link
              to="/create-match"
              className="px-6 py-2.5 rounded-lg bg-violet-600 hover:bg-violet-500 text-white text-sm font-semibold transition-colors duration-150 shadow-lg shadow-violet-900/30"
            >
              {t('welcome_playNow')}
            </Link>
          ) : (
            <Link
              to="/login"
              className="px-6 py-2.5 rounded-lg bg-violet-600 hover:bg-violet-500 text-white text-sm font-semibold transition-colors duration-150 shadow-lg shadow-violet-900/30"
            >
              {t('welcome_getStarted')}
            </Link>
          )}
          <Link
            to="/about"
            className="px-6 py-2.5 rounded-lg border border-white/10 text-zinc-300 hover:text-white hover:border-white/20 text-sm font-semibold transition-all duration-150"
          >
            {t('welcome_about')}
          </Link>
        </div>

        {/* Stats row */}
        <div className="flex items-center gap-8 mt-6 text-center">
          {[
            { label: t('welcome_statGameModes'), value: t('welcome_statGameModesValue') },
            { label: t('welcome_statPlayers'), value: t('welcome_statPlayersValue') },
            { label: t('welcome_statYear'), value: t('welcome_statYearValue') },
          ].map(({ label, value }) => (
            <div key={label} className="flex flex-col gap-0.5">
              <span className="text-2xl font-bold text-white">{value}</span>
              <span className="text-xs text-zinc-500 uppercase tracking-wider">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
